import * as React from 'react';
import {
    //FilterLiveSearch,
    NumberField,
    useLocale,
    ReferenceField, ReferenceInput, AutocompleteInput, TextField, NumberInput
} from 'react-admin';

import {EditableDatagrid, RowForm} from "@react-admin/ra-editable-datagrid";
import ListComponentAdmin from "../_common/ListComponentAdmin";
import TableActions from "../_common/TableActions";
import useMyStyles from "../utils/useMyStyles";
// import {universalTopFilters} from "../universalView/universalTopFilters";
// import {CardContent, useMediaQuery} from "@material-ui/core";
import {CardContent} from "@material-ui/core";
import CardComp from "../_common/CardComp";
import {
    DateFieldComp,
    FilterDataAside, TextFieldBold,
    //TextFieldBold
} from "../_common/CompReact";
import {validateReq} from "../utils/validateTable";
import {DeleteWithConfirmIconButton, EditRowButton} from "@react-admin/ra-editable-datagrid";

const universalTopFilters = (resource, locale) => {
    let dt = [];
    dt.push(<ReferenceInput source="expenses_type_id" reference="exp_types" label={'Type'} alwaysOn>
        <AutocompleteInput optionText="name" resettable emptyText={'All Types'}/>
    </ReferenceInput>);
    // dt.push(<TextInput label="Search" source="q" alwaysOn/>)
    // dt.push(<TextInput label="Brand" source="brand" defaultValue="Hello, World!"/>);
    return dt;
}

const UniversalAside = (props) => {
    //const {locale} = props;
    return (
        <CardComp id="aside_card">
            <CardContent>
                {/*<FilterLiveSearch/>*/}
                <FilterDataAside fields={'created_at'} name={'create'}/>
                <FilterDataAside fields={'updated_at'} name={'update'}/>
            </CardContent>
        </CardComp>
    )
};

/*
const handleTransform = (data) => {
    clearLocalStorage()
    return data;
    /!*return {
      ...data,
      fullName: `${data.firstName} ${data.name}`,
    };*!/
};
*/
const ListEditForm = (props) => {
    // const {classes, locale} = props;
    const {classes} = props;
    return (
        <RowForm
            {...props}
            //transform={handleTransform}
        >
            <NumberField source="id" headerClassName={classes.headerShortWidth}/>
            <ReferenceInput source="expenses_type_id" reference="exp_types" label={'Type'} validate={validateReq}>
                <AutocompleteInput resettable optionText="name" fullWidth/>
            </ReferenceInput>
            <ReferenceInput source="property_id" reference="exp_properties" label={'Property'} validate={validateReq}>
                <AutocompleteInput resettable optionText="name" fullWidth/>
            </ReferenceInput>
            <NumberInput source="order" label={'Order'} validate={validateReq}/>
            <DateFieldComp source="created_at" label={'Create'} textAlign={'center'} showTime={true}
                           locale={'us'} cellClassName={classes.date_st}/>
            <DateFieldComp source="updated_at" label={'Update'} textAlign={'center'} showTime={true}
                           locale={'us'} cellClassName={classes.date_st}/>
        </RowForm>
    )
};

/*export const tableFilters = [
    <TextInput label="Search" source="q" alwaysOn/>,
    /!*<BooleanInput label="Only viewed" source="viewed" alwaysOff/>,*!/
];*/
const CustomAction = () => (
    <>
        <EditRowButton/>
        <DeleteWithConfirmIconButton
            mutationMode="undoable"
            onClick={() => {
                console.log('DELETE========>');
            }}
        />
    </>
);
export const PropTypesBelongs = props => {
    const classes = useMyStyles();
    const {resource} = props;

    // console.log('resource=============>', resource)
    // const {id} = record || {};
    const locale = useLocale();
    return (
        <ListComponentAdmin
            {...props}
            //hasCreate={true}
            title={' '}
            actions={<TableActions
                preference={`${resource}${".list.columns"}`}
                select={false}
                create={true}
                filter={true}
            />}
            // is_bulkActionButtons={false}
            filters={universalTopFilters(resource, locale)}
            sort={{field: 'id', order: 'DESC'}}
            aside={<UniversalAside locale={locale}/>}
        >
            <EditableDatagrid
                actions={<CustomAction/>}
                classes={{headerCell: classes.headerCell, row: classes.row, rowCell: classes.rowCell}}
                //noDelete={true}
                // initialRowMode="edit"
                rowClick="edit"
                mutationMode="pessimistic" //Подтвердить удаление
                undoable
                createForm={<ListEditForm locale={locale} classes={classes} {...props} submitOnEnter={false}/>}
                editForm={<ListEditForm locale={locale} classes={classes} {...props} submitOnEnter={true}/>}
            >
                <NumberField source="id" headerClassName={classes.headerShortWidth}/>
                <ReferenceField source="expenses_type_id" reference="exp_types" label={'Type'} link={false}
                                sortBy={'exp_types:name'}>
                    <TextFieldBold source="name"/>
                </ReferenceField>
                <ReferenceField source="property_id" reference="exp_properties" label={'Property'} link={false}
                                sortBy={'exp_properties:name'}>
                    <TextFieldBold source="name"/>
                </ReferenceField>
                <TextField source="order" label={'Order'} textAlign={"right"}/>
                <DateFieldComp source="created_at" label={'Create'} textAlign={'center'} showTime={true}
                               locale={'us'} cellClassName={classes.date_st}/>
                <DateFieldComp source="updated_at" label={'Update'} textAlign={'center'} showTime={true}
                               locale={'us'} cellClassName={classes.date_st}/>
            </EditableDatagrid>
        </ListComponentAdmin>
    )
};
